export default __webpack_public_path__ + "static/media/MardyCrane.7279b363.jpg";